<template>
    <div class="u-d-flex">
        <div class="u-position-relative" :class="{'c-option-list--select-style' : selectStyle}" @click="updateListOptions()">
            <div id="c-option-list__parent-heading" class="c-option-list__parent-heading u-d-inline-block">
                <h2 class="c-option-list__heading" :class="name">
                    {{heading}}
                </h2>

                <svg v-if="selectStyle" viewBox="0 0 120 120">
                    <use xlink:href="#select-arrow" id="c-option-list__arrow"></use>
                </svg>
                <svg v-else viewBox="0 0 120 120">
                    <use xlink:href="#triangle-down" id="c-option-list__arrow"></use>
                </svg>
            </div>

            <div id="c-option-list" class="c-option-list" :class="name">
                <ul>
                    <slot></slot>
                </ul>
            </div>
        </div>
        <div v-if="filterSelected" @click="resetDefaultHeading">
            <slot name="add"></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'option-list',
        data: function() {
            return {
                filterSelected: false
            }
        },
        props: {
            heading: {
                type: String,
                default: 'Please select'
            },
            defaultHeading: {
                type: String,
                default: ''
            },
            selectStyle: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                default: ''
            },
        },
        methods: {
            resetDefaultHeading(){
                this.filterSelected = false;
                let currentHeading = document.querySelector(".c-option-list__heading." + this.name);
                currentHeading.innerHTML = this.defaultHeading;
            },
            updateListOptions(){
                // let listOptions = document.querySelector('.c-option-list');
                const listOptions = document.querySelector("div.c-option-list." + this.name);
                const listOptionsAll = document.querySelectorAll("div.c-option-list");
                for (var i = 0; i < listOptionsAll.length; i++) {
                    listOptionsAll[i].style.display = listOptionsAll[i].style.display === 'block' ? '' : '';
                }
                //show/hide dropdown
                listOptions.style.display = listOptions.style.display === 'block' ? '' : 'block';

                const body = document.querySelector('body');

                //add a click listener to the body to listen for close dropdown if open
                body.addEventListener('click', bodyFunction);

                //create variables to stop clashes in multiple dropdown instance selections
                const currentHeadingString = 'c-option-list__heading ' + this.name;
                let currentHeading = document.querySelector(".c-option-list__heading." + this.name);

                function bodyFunction(e) {
                  if(
                    e.target.id !== 'c-option-list'
                 && e.target.id !== 'c-option-list__parent-heading'
                 && !e.target.classList.contains('c-option-list--select-style')
                 && e.target.id !== 'c-option-list__arrow'
                 //fix for svg click on ie11
                 && e.target.className !== undefined
                 && e.target.className !== currentHeadingString
                 ) {
                     //if anywhere but the dropdown or dropdown heading is clicked hide the dropdown
                    listOptions.style.display = "none";
                    //remove the listener from the body when dropdown not in use
                    body.removeEventListener('click', bodyFunction);
                  }
                }

                //add a click listener to the document to listen for escape key press to close dropdown if open
                document.addEventListener('keydown', event => {
                    if (event.key === 'Escape' || event.keyCode === 27) {
                        for (var i = 0; i < listOptionsAll.length; i++) {
                            listOptionsAll[i].style.display = listOptionsAll[i].style.display === 'block' ? '' : '';
                        }
                    }
                });

                //assign variables to list items
                const listItems = document.querySelectorAll('.c-option-list.' + this.name + ' ul li');
                const listItemsNonClick = document.querySelectorAll('.c-option-list.' + this.name + ' ul li.c-option-list__non-click');

                //loop through list items and add a click to each
                listItems.forEach(clickElement => clickElement.addEventListener('click', updateHeader));
                //remove click from list items that don't need them
                listItemsNonClick.forEach(clickElement => clickElement.removeEventListener('click', updateHeader));

                let thisScope = this;
                
                //update the value of the h2 tag with what list item has been clicked
                function updateHeader(e) {
                    currentHeading.innerHTML = e.target.innerHTML;
                    thisScope.filterSelected = true;
                }
            }
        }
    }

</script>

<style lang="scss">
    @import '../assets/sass/base/colours.scss';
    @import '../assets/sass/view/component/option-list.scss';
</style>


// WEBPACK FOOTER //
// OptionList.vue?5d28f6a0